import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Login.css";

let data;
let token;

const Login = () => {

  const [username, setUsername]=useState('');
  const [password, setPassword]=useState('');
  const [wallet, setWallet]=useState(0);
  const [viewLoading,setViewLoading]=useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const history=useHistory();


  data={
    'usr':username,
    'pass':password,
    'wallet':wallet
  };
  // TODO: CRIO_TASK_MODULE_LOGIN - Fetch the API response
  /**
   * Perform the Login API call
   * @param {{ username: string, password: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/login"
   *
   * Example for successful response from backend:
   * HTTP 201
   * {
   *      "success": true,
   *      "token": "testtoken",
   *      "username": "criodo",
   *      "balance": 5000
   * }
   *
   * Example for failed response from backend:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Password is incorrect"
   * }
   *
   */
  const login = async (data) => {
    setViewLoading(true)
    try{
       token=await axios.post(`${config.endpoint}/auth/login`,{
        username: data.usr,
        password:data.pass,
        //wallet:data.wallet
      })
      console.log(token.data);
       setViewLoading(false);

       enqueueSnackbar('Logged in successfully', {
        variant: 'success'
      })
    
      persistLogin(token.data.token, token.data.username, token.data.balance)
      history.push("/",{from:"Login"})
      }
      catch(error){ 
        //console.log(error.message)
        setViewLoading(false);
        // enqueueSnackbar(error.response.data.message,{
        //   variant:'error'
        // })
      if(error.response){
        if(error.response.status>=400){
        enqueueSnackbar(error.response.data.message, {
          variant: 'error'
        })}
       }
       else if(error.request){
        enqueueSnackbar("Something went wrong. Check that the backend is running, reachable and returns valid JSON.", {
          variant: 'error'
        })
       }
        else{
          enqueueSnackbar("Something went wrong. Check that the backend is running, reachable and returns valid JSON.", {
            variant: 'error'
          })
        }
      }
  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Validate the input
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false and show warning message if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that password field is not an empty value - "Password is a required field"
   */
  const validateInput = (data) =>{
     if(data.usr==''){
      return enqueueSnackbar("Username is a required field",{
        variant:'warning'
      })
     }
     else if(data.pass==''){
      return enqueueSnackbar("Password is a required field",{
        variant:'warning'
      })
     }
     return true
  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Persist user's login information
  /**
   * Store the login information so that it can be used to identify the user in subsequent API calls
   *
   * @param {string} token
   *    API token used for authentication of requests after logging in
   * @param {string} username
   *    Username of the logged in user
   * @param {string} balance
   *    Wallet balance amount of the logged in user
   *
   * Make use of localStorage: https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage
   * -    `token` field in localStorage can be used to store the Oauth token
   * -    `username` field in localStorage can be used to store the username that the user is logged in as
   * -    `balance` field in localStorage can be used to store the balance amount in the user's wallet
   */
  const persistLogin = (token, username, balance) => {
    if(token){
      localStorage.setItem("username",username);
      localStorage.setItem("token",token);
      localStorage.setItem("balance", balance);
    }
  };

  if(viewLoading==false){
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons/>
      <Box className="content">
        <Stack spacing={2} className="form">
        <h2 className="title">Login</h2>
        <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Enter Username"
            onChange={(event)=>{
              setUsername(event.target.value)
            }}
            fullWidth
          />
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            onChange={(event)=>{
              setPassword(event.target.value)
            }}
            fullWidth
          />

          <Button className="button" variant="contained" onClick={ async()=>{
            if(validateInput(data)==true){
                await login(data);
            }
            else{
              validateInput(data)
            }
          }
          }
          >
            Login to QKart
           </Button>
           <p className="secondary-action">
           {"  "}Don’t have an account?{"  "}
           <Link to="/register">Register Now</Link>
          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  )
}

else if(viewLoading==true){
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons={true}/>
      <Box className="content">
        <Stack spacing={2} className="form">
        <h2 className="title">Login</h2>
        <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Enter Username"
            onChange={(event)=>{
              setUsername(event.target.value)
            }}
            fullWidth
          />
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            onChange={(event)=>{
              setPassword(event.target.value)
            }}
            fullWidth
          />

           <Box sx={{ display: 'flex', justifyContent:'center' }}>
             <CircularProgress />
           </Box>

           <p className="secondary-action">
           {"  "}Don’t have an account?{"  "}
             <a className="link" href="#">
              Register Now
             </a>
          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
}
}


export default Login;

